import React from "react";
import "./EventCard.css";

/**
 * EventCard
 * Props:
 *  - month, day     e.g. "Jul", "12" — drives the date badge
 *  - title          e.g. "Community Listening"
 *  - time, location e.g. "7:00 PM", "Oakland, CA"
 *  - imageSrc       optional — renders a photo strip above the existing
 *                    layout; omitted entirely (no layout change at all)
 *                    when not provided, so every other place this card
 *                    is already used (which never passes an image)
 *                    stays visually identical.
 *  - ctaLabel / onCtaClick   defaults to "Details"
 */
export default function EventCard({
  month = "Jul",
  day = "12",
  title = "Untitled event",
  time = "7:00 PM",
  location = "TBD",
  imageSrc,
  ctaLabel = "Details",
  onCtaClick,
}) {
  return (
    <div className="event-card2">
      {imageSrc && (
        <div className="event-card2-image-wrap">
          <img className="event-card2-image" src={imageSrc} alt={title} />
        </div>
      )}
      <div className="event-card2-row">
        <div className="event-card2-date">
          <span className="event-card2-month">{month}</span>
          <span className="event-card2-day">{day}</span>
        </div>
        <div className="event-card2-body">
          <div className="event-card2-title">{title}</div>
          <div className="event-card2-meta">{time} · {location}</div>
          {ctaLabel && (
            <button className="event-card2-cta" onClick={onCtaClick}>
              {ctaLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}